import { render, staticRenderFns } from "./arinvlist.vue?vue&type=template&id=894d5a72"
import script from "./arinvlist.vue?vue&type=script&lang=js"
export * from "./arinvlist.vue?vue&type=script&lang=js"
import style0 from "./arinvlist.vue?vue&type=style&index=0&id=894d5a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports